import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'

/* Право проверяем до действия входа: страница настроек открывается раньше поиска якоря */
export const appealsConditions: Record<string, () => boolean> = {
  'appeals.canSettings': () => {
    const permissionsStore = usePermissionsStore()

    return Boolean(permissionsStore.isSuperuser || permissionsStore.modules.appeals?.channel_edit)
  },
}
